import React from 'react'
import styles from './Dashboard.module.scss'
import { Analytics } from './Analytics/Analytics'
import { Table } from './Table/Table'
import { Icon } from 'components/Icon/Icon'
import { AnalyticsType, DashboardData } from './consts'
import { PopupWithdraw } from './PopupWithdraw/PopupWithdraw'


type Props = {
    data: DashboardData,
    analytics: AnalyticsType[],
}

export function Dashboard(props: Props) {
    const [showPopup, setShowPopup] = React.useState(false)

    function closePopup() {
        setShowPopup(false)
    }

    function openPopup(id) {
        setShowPopup(true)
        console.log('patron id', id)
    }

    return (
        <>
            <div className={styles['wrapper']} >
                <Analytics analytics={props.analytics} />
                <div className={styles['content']}>
                    <div className={styles['container']}>
                        <span className={styles['title']}>Patrons</span>
                        <Icon name='patrons' />
                    </div>
                    <Table data={props.data} onOpenWithdraw={openPopup} />
                </div>
            </div>
            {showPopup && <PopupWithdraw onClose={closePopup} />}
        </>
    );
}

